import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { palette } from '@leafygreen-ui/palette';

// types
import { onChangeTypeDef } from 'js/auth/types/formInput';

// utils
import { mq } from 'js/common/utils/mediaQueries';

// components
import PasswordInputWithValidationCriteria from 'js/auth/components/PasswordInputWithValidationCriteria';
import FormInput, { Input } from 'js/auth/components/FormInput';
import GoogleAuthButton, { GoogleAuthButtonProps } from 'js/auth/components/GoogleAuthButton';

// styles
import { getLabelStyle } from 'js/common/components/Vercel/styles/common';
interface PasswordInputProps {
  onChange?: onChangeTypeDef;
  value?: string;
  hasError?: boolean;
  errorMessage?: string;
  forNewUser?: boolean;
  tooltipText?: React.ReactNode;
  className?: string;
  disabled?: boolean;
}

const getInputStyle = (isDisabled?: boolean) => css`
  margin-bottom: 16px;
  ${Input} {
    width: 100%;
  }
  label {
    ${getLabelStyle(isDisabled)}
  }
`;

export const VercelPasswordInput = styled(PasswordInputWithValidationCriteria)<PasswordInputProps>`
  ${({ disabled }) => getInputStyle(disabled)}
`;

export const VercelFormInput = styled(FormInput)`
  ${({ disabled }) => getInputStyle(disabled)}
`;

export const vercelTextLinkStyle = css`
  color: ${palette.blue.base};
  text-decoration: none;
  cursor: pointer;
  font-weight: 500;
  line-height: 24px;
`;

export const VercelRedirectText = styled.span`
  color: ${palette.gray.dark2};
  display: block;
  font-size: 16px;
  font-weight: 400;
  a {
    ${vercelTextLinkStyle}
  }
`;

export const VercelGoogleAuthButton = styled(GoogleAuthButton)<GoogleAuthButtonProps>(
  mq({ width: ['100%', '100%', '100%', '100%'] })
);
